import React, { useState, useEffect, useRef, useContext } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { head } from "lodash";
import * as XLSX from "xlsx";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import Chip from '@material-ui/core/Chip';
import RepeatIcon from '@material-ui/icons/Repeat';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { isNil } from "lodash";
import { i18n } from "../../translate/i18n";
import moment from "moment";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  FormControlLabel,
  Switch,
  Typography,
  Collapse,
  List,
  ListItem,
  ListItemText,
  FormHelperText,
  Card,
  CardContent,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import ConfirmationModal from "../ConfirmationModal";
import UserStatusIcon from "../UserModal/statusIcon";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import useQueues from "../../hooks/useQueues";
import ValidateContactListModal from "../ValidateContactListModal";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  recurrenceCard: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  previewCard: {
    marginTop: theme.spacing(1),
    maxHeight: 200,
    overflow: 'auto',
  },
  recurrenceIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  warningText: {
    flex: 1,
    color: theme.palette.error.light,
    fontStyle: "italic",
    fontSize: "0.72rem",
    padding: "0 8px",
  },
}));


// No CampaignModal.js - Atualizar o schema de validação

const CampaignSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  isRecurring: Yup.boolean().default(false),
  recurrenceType: Yup.string().when('isRecurring', {
    is: true,
    then: Yup.string().oneOf(['minutely', 'hourly', 'daily', 'weekly', 'biweekly', 'monthly', 'yearly']).required('Tipo de recorrência é obrigatório'),
    otherwise: Yup.string().nullable()
  }),
  recurrenceInterval: Yup.number().when('isRecurring', {
    is: true,
    then: Yup.number().min(1, 'Intervalo deve ser maior que 0').required('Intervalo é obrigatório'),
    otherwise: Yup.number().nullable()
  }),
  // CORREÇÃO: Validar como array mas permitir vazio
  recurrenceDaysOfWeek: Yup.array().when(['isRecurring', 'recurrenceType'], {
    is: (isRecurring, recurrenceType) => isRecurring && recurrenceType === 'weekly',
    then: Yup.array().min(1, 'Selecione pelo menos um dia da semana').required(),
    otherwise: Yup.array().nullable()
  }),
  recurrenceDayOfMonth: Yup.number().when(['isRecurring', 'recurrenceType'], {
    is: (isRecurring, recurrenceType) => isRecurring && recurrenceType === 'monthly',
    then: Yup.number().min(1, 'Dia deve ser entre 1 e 31').max(31, 'Dia deve ser entre 1 e 31').required('Dia do mês é obrigatório'),
    otherwise: Yup.number().nullable()
  }),
  recurrenceEndDate: Yup.date().when('isRecurring', {
    is: true,
    then: Yup.date().min(new Date(), 'Data final deve ser futura').nullable(),
    otherwise: Yup.date().nullable()
  }),
  maxExecutions: Yup.number().when('isRecurring', {
    is: true,
    then: Yup.number().min(1, 'Número máximo deve ser maior que 0').nullable(),
    otherwise: Yup.number().nullable()
  })
});

const CampaignModal = ({
  open,
  onClose,
  campaignId,
  isTemplate,
  initialValues,
  onSave,
  resetPagination,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMounted = useRef(true);
  const { user, socket } = useContext(AuthContext);
  const { companyId } = user;

  const initialState = {
    name: "",
    message1: "",
    message2: "",
    message3: "",
    message4: "",
    message5: "",
    confirmationMessage1: "",
    confirmationMessage2: "",
    confirmationMessage3: "",
    confirmationMessage4: "",
    confirmationMessage5: "",
    status: "INATIVA",
    confirmation: false,
    scheduledAt: "",
    contactListId: "",
    tagListId: "Nenhuma",
    companyId,
    statusTicket: "closed",
    openTicket: "disabled",
    // Novos campos de recorrência
    isRecurring: false,
    recurrenceType: "",
    recurrenceInterval: 1,
    recurrenceDaysOfWeek: [],
    recurrenceDayOfMonth: 1,
    recurrenceEndDate: "",
    maxExecutions: null,
  };

  const [campaign, setCampaign] = useState(initialState);
  const [whatsapps, setWhatsapps] = useState([]);
  const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
 const [whatsappId, setWhatsappId] = useState(null);
  const [contactLists, setContactLists] = useState([]);
  const [tagLists, setTagLists] = useState([]);
  const [messageTab, setMessageTab] = useState(0);
  const [attachment, setAttachment] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [campaignEditable, setCampaignEditable] = useState(true);
  const [previewExecutions, setPreviewExecutions] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const attachmentFile = useRef(null);

  const [options, setOptions] = useState([]);
  const [queues, setQueues] = useState([]);
  const [allQueues, setAllQueues] = useState([]);

  const [validateModalOpen, setValidateModalOpen] = useState(false);
  // Guarda só o último resultado da validação por lista (não precisa ser
  // persistido entre sessões) — serve para avisar o usuário que a lista
  // mudou desde a última validação, caso ele troque a lista selecionada.
  const [validatedContactListId, setValidatedContactListId] = useState(null);

  // Tipo de campanha: "normal" ou "template" — fixado se vier isTemplate
  const [campaignType, setCampaignType] = useState(isTemplate ? "template" : "normal");

  // Sincroniza quando o modal abre/fecha ou isTemplate muda
  useEffect(() => {
    setCampaignType(isTemplate ? "template" : "normal");
  }, [isTemplate, open]);

  // Quando muda para template, garante que conexão selecionada é oficial
  useEffect(() => {
    if (campaignType === "template" && whatsappId && whatsapps.length > 0) {
      const selected = whatsapps.find(w => w.id === whatsappId);
      if (selected && selected.channel !== "whatsapp_oficial") {
        setWhatsappId(null);
      }
    }
  }, [campaignType, whatsapps]);

  // Limpa campos do formulário ao trocar de aba (apenas em criação)
  const handleCampaignTypeChange = (newType, setFieldValue) => {
    if (campaignId) return; // não limpa na edição
    setCampaignType(newType);
    // Reset de todos os campos do form
    Object.keys(initialState).forEach(key => setFieldValue(key, initialState[key]));
    setWhatsappId(null);
    setSelectedUser(null);
    setSelectedQueue(null);
    setTemplateName("");
    setTemplateBody("");
    setTemplateFile(null);
    setParsedItems([]);
    setAttachment(null);
  };

  // Template Meta
  const [templateName, setTemplateName] = useState("");
  const [templateBody, setTemplateBody] = useState("");
  const [templateFile, setTemplateFile] = useState(null);
  const [parsedItems, setParsedItems] = useState([]);
  const [existingItemsCount, setExistingItemsCount] = useState(0);
  const templateFileRef = useRef(null);

  const handleDownloadTemplate = async (contactListId) => {
    if (!contactListId) {
      toast.error("Selecione uma Lista de Contato antes de baixar o template.");
      return;
    }
    try {
      const { data } = await api.get(`/contact-list-items/list`, { params: { contactListId, companyId } });
      const allContacts = Array.isArray(data) ? data : (data.contacts || []);
      // Contatos já validados (isWhatsappValid === false) ficam de fora do
      // template — foram confirmados sem WhatsApp na checagem feita pelo
      // botão "Validar contatos". isWhatsappValid null/undefined (nunca
      // validado) continua entrando normalmente, sem bloquear o fluxo de
      // quem não usou a validação.
      const contacts = allContacts.filter(c => c.isWhatsappValid !== false);
      const skippedCount = allContacts.length - contacts.length;
      // "NÃO EDITAR" (coluna oculta, sempre na posição A): guarda o ID do
      // ContactListItem para o disparo identificar o contato exato, sem
      // depender só do nome — que é ambíguo quando há nomes duplicados na
      // Lista de Contato (ex: múltiplos "Andre"). Fica sempre na primeira
      // coluna (não depois de Parâmetro N/Valor N, que variam de
      // quantidade conforme o template) para a posição nunca mudar. O
      // cabeçalho é o próprio aviso, caso o usuário reexiba colunas ocultas
      // no Excel e veja a coluna por acidente.
      const rows = contacts.map(c => ({
        "NÃO EDITAR (ID interno)": c.id,
        "Nome do contato": c.name || "",
        "Parâmetro 1": "",
        "Valor 1": "",
      }));
      if (rows.length === 0) rows.push({ "NÃO EDITAR (ID interno)": "", "Nome do contato": "", "Parâmetro 1": "", "Valor 1": "" });
      const ws = XLSX.utils.json_to_sheet(rows);
      ws["!cols"] = [{ hidden: true }, { wch: 30 }, { wch: 20 }, { wch: 30 }];
      // Comentário na célula do cabeçalho: reforço visual do aviso caso o
      // usuário reexiba a coluna oculta no Excel e não repare no nome dela.
      if (ws["A1"]) {
        ws["A1"].c = [{
          a: "GoLiveZap",
          t: "Não edite, apague ou reordene esta coluna. Ela é usada internamente para identificar o contato correto durante o envio, mesmo quando há nomes repetidos na lista.",
        }];
      }
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Template");
      XLSX.writeFile(wb, `template_${templateName || "campanha"}.xlsx`);
      toast.success(
        skippedCount > 0
          ? `Template gerado com ${rows.length} contatos! (${skippedCount} sem WhatsApp foram excluídos)`
          : `Template gerado com ${rows.length} contatos!`
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleImportTemplate = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });
        const items = rows.map((row) => {
          const contactName = row["Nome do contato"] || "";
          const contactNumber = row["Número"] || row["Numero"] || "";
          // "NÃO EDITAR (ID interno)": coluna oculta injetada no template
          // exportado (ver handleDownloadTemplate) — identifica o contato
          // exato na Lista de Contato, sem ambiguidade em caso de nomes
          // duplicados. Lida pelo nome do cabeçalho (não pela posição), já
          // que sheet_to_json indexa por cabeçalho — então funciona mesmo
          // com qualquer quantidade de colunas de parâmetro. "_cid" fica só
          // como fallback de planilhas baixadas na primeira versão desta
          // funcionalidade (nome de coluna antigo). Planilhas ainda mais
          // antigas (sem nenhuma das duas) não têm essa coluna; o backend
          // cai de volta para a busca por nome nesse caso.
          const rawCid = row["NÃO EDITAR (ID interno)"] ?? row["_cid"];
          const contactListItemId = rawCid !== "" && rawCid !== undefined
            ? Number(rawCid)
            : null;
          const variables = {};
          let n = 1;
          while (row[`Parâmetro ${n}`] !== undefined || row[`Parametro ${n}`] !== undefined) {
            const param = row[`Parâmetro ${n}`] || row[`Parametro ${n}`] || "";
            const val = row[`Valor ${n}`] || "";
            if (param) variables[param] = val;
            n++;
          }
          return { contactName, contactNumber, contactListItemId, variables };
        }).filter(i => i.contactName);
        setParsedItems(items);
        setTemplateFile(file);
        toast.success(`${items.length} registros carregados!`);
      } catch (err) {
        toast.error("Erro ao ler o arquivo Excel.");
      }
    };
    reader.readAsBinaryString(file);
    e.target.value = "";
  };
  const handleDownloadExistingItems = async () => {
    try {
      // Busca todos os itens em páginas de 50
      let allItems = [];
      let page = 1;
      let hasMore = true;
      while (hasMore) {
        const { data } = await api.get(`/meta-templates/${campaignId}/items`, {
          params: { pageNumber: page, pageSize: 5000 },
        });
        allItems = [...allItems, ...(data.records || [])];
        hasMore = data.hasMore;
        page++;
      }
      if (allItems.length === 0) {
        toast.warn("Nenhum item cadastrado neste template.");
        return;
      }
      // Descobre todos os parâmetros únicos usados
      const allParams = new Set();
      allItems.forEach(item => {
        Object.keys(item.variables || {}).forEach(p => allParams.add(p));
      });
      const paramList = Array.from(allParams);
      // Monta as linhas
      const rows = allItems.map(item => {
        const row = { "Nome do contato": item.contactName };
        paramList.forEach((param, i) => {
          row[`Parâmetro ${i + 1}`] = param;
          row[`Valor ${i + 1}`] = item.variables?.[param] || "";
        });
        return row;
      });
      const ws = XLSX.utils.json_to_sheet(rows);
      ws["!cols"] = [{ wch: 30 }, ...paramList.flatMap(() => [{ wch: 20 }, { wch: 30 }])];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Template");
      XLSX.writeFile(wb, `template_editado_${templateName || campaignId}.xlsx`);
      toast.success(`${allItems.length} itens exportados!`);
    } catch (err) {
      toastError(err);
    }
  };

  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const { findAll: findAllQueues } = useQueues();

  // Opções para dias da semana
  const daysOfWeekOptions = [
    { value: 0, label: 'Domingo' },
    { value: 1, label: 'Segunda-feira' },
    { value: 2, label: 'Terça-feira' },
    { value: 3, label: 'Quarta-feira' },
    { value: 4, label: 'Quinta-feira' },
    { value: 5, label: 'Sexta-feira' },
    { value: 6, label: 'Sábado' },
  ];

  // Função para preview das execuções
  const handlePreviewRecurrence = async (values) => {
    if (!values.isRecurring || !values.recurrenceType || !values.scheduledAt) {
      setPreviewExecutions([]);
      return;
    }

    try {
      const params = {
        recurrenceType: values.recurrenceType,
        recurrenceInterval: values.recurrenceInterval,
        recurrenceDaysOfWeek: JSON.stringify(values.recurrenceDaysOfWeek),
        recurrenceDayOfMonth: values.recurrenceDayOfMonth,
      };

      if (campaignId) {
        const { data } = await api.get(`/campaigns/${campaignId}/recurrence-preview`, { params });
        setPreviewExecutions(data.executions);
      } else {
        // Para campanhas novas, calcular localmente ou usar endpoint genérico
        const mockExecutions = calculateMockExecutions(values);
        setPreviewExecutions(mockExecutions);
      }
    } catch (err) {
      console.error('Erro ao buscar preview:', err);
    }
  };

  // Função auxiliar para calcular execuções mock
  const calculateMockExecutions = (values) => {
    const executions = [];
    let currentDate = moment(values.scheduledAt);
    
    for (let i = 0; i < 5; i++) {
      executions.push(currentDate.format('DD/MM/YYYY HH:mm'));
      
      switch (values.recurrenceType) {
        case 'minutely':
          currentDate = currentDate.clone().add(values.recurrenceInterval, 'minutes');
          break;
        case 'hourly':
          currentDate = currentDate.clone().add(values.recurrenceInterval, 'hours');
          break;
        case 'daily':
          currentDate = currentDate.clone().add(values.recurrenceInterval, 'days');
          break;
        case 'weekly':
          currentDate = currentDate.clone().add(values.recurrenceInterval, 'weeks');
          break;
        case 'biweekly':
          currentDate = currentDate.clone().add(values.recurrenceInterval * 2, 'weeks');
          break;
        case 'monthly':
          currentDate = currentDate.clone().add(values.recurrenceInterval, 'months');
          if (values.recurrenceDayOfMonth) {
            currentDate = currentDate.date(values.recurrenceDayOfMonth);
          }
          break;
        case 'yearly':
          currentDate = currentDate.clone().add(values.recurrenceInterval, 'years');
          break;
      }
    }
    
    return executions;
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);
        setQueues(list);
      };
      loadQueues();
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/users/")
      .then(({ data }) => setOptions(data.users))
      .catch(toastError)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      if (initialValues) {
        setCampaign((prevState) => {
          return { ...prevState, ...initialValues };
        });
      }

      api
        .get(`/contact-lists/list`, { params: { companyId } })
        .then(({ data }) => setContactLists(data));

      api
        .get(`/whatsapp`, { params: { companyId, session: 0 } })
        .then(({ data }) => {
          const mappedWhatsapps = data.map((whatsapp) => ({
            ...whatsapp,
            selected: false,
          }));
          setWhatsapps(mappedWhatsapps);
        });

      api.get(`/tags/list`, { params: { companyId, kanban: 0 } })
        .then(({ data }) => {
          const fetchedTags = data;
          const formattedTagLists = fetchedTags
            .filter(tag => tag.contacts.length > 0)
            .map((tag) => ({
              id: tag.id,
              name: `${tag.name} (${tag.contacts.length})`,
            }));
          setTagLists(formattedTagLists);
        })
        .catch((error) => {
          console.error("Error retrieving tags:", error);
        });

      if (!campaignId) return;

      const endpoint = isTemplate ? `/meta-templates/${campaignId}` : `/campaigns/${campaignId}`;
      api.get(endpoint).then(({ data }) => {
        if (data?.templateName) setTemplateName(data.templateName);
        if (data?.templateBody) setTemplateBody(data.templateBody);
        if (isTemplate && data?.items) setExistingItemsCount(data.items.length);
        if (data?.user) setSelectedUser(data.user);
        if (data?.queue) setSelectedQueue(data.queue.id);
        if (data?.whatsappId) {
          setWhatsappId(parseInt(data.whatsappId));
        } else {
          setWhatsappId(null);
        }

        setCampaign((prev) => {
          let prevCampaignData = Object.assign({}, prev);

          Object.entries(data).forEach(([key, value]) => {
            if (key === "scheduledAt" && value !== "" && value !== null) {
              prevCampaignData[key] = moment(value).format("YYYY-MM-DDTHH:mm");
            } else if (key === "recurrenceEndDate" && value !== "" && value !== null) {
              prevCampaignData[key] = moment(value).format("YYYY-MM-DD");
            } else if (key === "recurrenceDaysOfWeek" && value) {
              prevCampaignData[key] = JSON.parse(value);
            } else {
              // Garante que IDs numéricos fiquem como número (Formik Select precisa do mesmo tipo)
              prevCampaignData[key] = value === null ? "" : value;
            }
          });

          // Força contactListId como número se vier do backend
          if (data.contactListId) {
            prevCampaignData.contactListId = parseInt(data.contactListId);
          }

          return prevCampaignData;
        });
      });
    }
  }, [campaignId, open, initialValues, companyId]);

  useEffect(() => {
    if (isTemplate) {
      setCampaignEditable(true);
      return;
    }
    const now = moment();
    const scheduledAt = moment(campaign.scheduledAt);
    const moreThenAnHour =
      !Number.isNaN(scheduledAt.diff(now)) && scheduledAt.diff(now, "hour") > 1;
    const isEditable =
      campaign.status === "INATIVA" ||
      (campaign.status === "PROGRAMADA" && moreThenAnHour);

    setCampaignEditable(isEditable);
  }, [campaign.status, campaign.scheduledAt, isTemplate]);

  const handleClose = () => {
    onClose();
    setCampaign(initialState);
    setPreviewExecutions([]);
    setShowPreview(false);
    setTemplateName("");
    setTemplateBody("");
    setTemplateFile(null);
    setParsedItems([]);
    setExistingItemsCount(0);
  };

  const handleAttachmentFile = (e) => {
    const file = head(e.target.files);
    if (file) {
      setAttachment(file);
    }
  };

const handleSaveCampaign = async (values) => {
  try {
    // Validar que o agendamento é no futuro
    if (values.scheduledAt) {
      const scheduled = moment(values.scheduledAt);
      if (scheduled.isSameOrBefore(moment())) {
        toast.error("O agendamento deve ser em uma data e hora futura.");
        return;
      }
    }

    const dataValues = {
      ...values,
      whatsappId: whatsappId,
      userId: selectedUser?.id || null,
      queueId: selectedQueue || null,
      recurrenceDaysOfWeek: (values.isRecurring && values.recurrenceDaysOfWeek && values.recurrenceDaysOfWeek.length > 0)
        ? values.recurrenceDaysOfWeek
        : null,
    };

    // Processar datas
    Object.entries(values).forEach(([key, value]) => {
      if (key === "scheduledAt" && value !== "" && value !== null) {
        dataValues[key] = moment(value).format("YYYY-MM-DD HH:mm:ss");
      } else if (key === "recurrenceEndDate" && value !== "" && value !== null) {
        dataValues[key] = moment(value).format("YYYY-MM-DD HH:mm:ss");
      } else if (key !== "recurrenceDaysOfWeek" && key !== "whatsappId") {
        // whatsappId já foi definido acima a partir do state `whatsappId`
        // (fonte de verdade real, controlado manualmente pelo Select) — o
        // Formik values.whatsappId só existe porque o load da campanha
        // (useEffect acima) copia toda chave vinda do backend para dentro
        // de `campaign`/initialValues, e nunca é atualizado quando o
        // usuário troca a conexão no Select. Sem esta exclusão, este loop
        // rodava por cima e sobrescrevia de volta pro valor antigo
        // carregado do backend, fazendo a troca de conexão nunca ser salva.
        dataValues[key] = value === "" ? null : value;
      }
    });

    if (!values.isRecurring) {
      dataValues.recurrenceType = null;
      dataValues.recurrenceInterval = null;
      dataValues.recurrenceDaysOfWeek = null;
      dataValues.recurrenceDayOfMonth = null;
      dataValues.recurrenceEndDate = null;
      dataValues.maxExecutions = null;
    }

    // ── TEMPLATE META ──────────────────────────────────────────
    if (campaignType === "template") {
      if (!templateName.trim()) {
        toast.warn("Informe o Nome do template Meta (nome aprovado na Meta).");
        return;
      }
      const templateData = { ...dataValues, templateName, templateBody, items: parsedItems };
      if (campaignId) {
        await api.put(`/meta-templates/${campaignId}`, templateData);
        if (parsedItems.length > 0) {
          await api.post(`/meta-templates/${campaignId}/import`, { items: parsedItems });
        }
      } else {
        await api.post("/meta-templates", templateData);
      }
      toast.success(i18n.t("campaigns.toasts.success"));
      if (resetPagination) resetPagination();
      handleClose();
      return;
    }
    // ── CAMPANHA NORMAL ────────────────────────────────────────

    if (campaignId) {
      await api.put(`/campaigns/${campaignId}`, dataValues);
      if (attachment != null) {
        const formData = new FormData();
        formData.append("file", attachment);
        await api.post(`/campaigns/${campaignId}/media-upload`, formData);
      }
      handleClose();
    } else {
      const { data } = await api.post("/campaigns", dataValues);
      if (attachment != null) {
        const formData = new FormData();
        formData.append("file", attachment);
        await api.post(`/campaigns/${data.id}/media-upload`, formData);
      }
      if (onSave) {
        onSave(data);
      }
      handleClose();
    }
    toast.success(i18n.t("campaigns.toasts.success"));
  } catch (err) {
    console.log(err);
    toastError(err);
  }
};

  const deleteMedia = async () => {
    if (attachment) {
      setAttachment(null);
      attachmentFile.current.value = null;
    }

    if (campaign.mediaPath) {
      await api.delete(`/campaigns/${campaign.id}/media-upload`);
      setCampaign((prev) => ({ ...prev, mediaPath: null, mediaName: null }));
      toast.success(i18n.t("campaigns.toasts.deleted"));
    }
  };

  const renderMessageField = (identifier) => {
    return (
      <Field
        as={TextField}
        id={identifier}
        name={identifier}
        fullWidth
        rows={5}
        label={i18n.t(`campaigns.dialog.form.${identifier}`)}
        placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
        multiline={true}
        variant="outlined"
        helperText="Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas."
        disabled={!campaignEditable && campaign.status !== "CANCELADA"}
      />
    );
  };

  const renderConfirmationMessageField = (identifier) => {
    return (
      <Field
        as={TextField}
        id={identifier}
        name={identifier}
        fullWidth
        rows={5}
        label={i18n.t(`campaigns.dialog.form.${identifier}`)}
        placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
        multiline={true}
        variant="outlined"
        disabled={!campaignEditable && campaign.status !== "CANCELADA"}
      />
    );
  };

  const cancelCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/cancel`);
      toast.success(i18n.t("campaigns.toasts.cancel"));
      setCampaign((prev) => ({ ...prev, status: "CANCELADA" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const restartCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/restart`);
      toast.success(i18n.t("campaigns.toasts.restart"));
      setCampaign((prev) => ({ ...prev, status: "EM_ANDAMENTO" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const filterOptions = createFilterOptions({
    trim: true,
  });

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={i18n.t("campaigns.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {campaignEditable ? (
            <>
              {campaignId
                ? `${i18n.t("campaigns.dialog.update")}`
                : `${i18n.t("campaigns.dialog.new")}`}
            </>
          ) : (
            <>{`${i18n.t("campaigns.dialog.readonly")}`}</>
          )}
        </DialogTitle>
        <div style={{ display: "none" }}>
          <input
            type="file"
            ref={attachmentFile}
            onChange={(e) => handleAttachmentFile(e)}
          />
        </div>
        <Formik
          initialValues={campaign}
          enableReinitialize={true}
          validationSchema={CampaignSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveCampaign(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form>
              <DialogContent dividers>
                {/* SELETOR DE TIPO DE CAMPANHA */}
                <Box style={{ marginBottom: 16 }}>
                  <Tabs
                    value={campaignType}
                    onChange={(e, v) => handleCampaignTypeChange(v, setFieldValue)}
                    indicatorColor="primary"
                    textColor="primary"
                  >
                    <Tab label="Nova Campanha" value="normal" disabled={!!campaignId && isTemplate} />
                    <Tab label="Template Meta" value="template" disabled={!!campaignId && !isTemplate} />
                  </Tabs>
                </Box>

                <Grid spacing={2} container>
                  <Grid xs={12} md={4} item>
                    <Field
                      as={TextField}
                      label={i18n.t("campaigns.dialog.form.name")}
                      name="name"
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                      disabled={!campaignEditable}
                    />
                  </Grid>
                  
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="confirmation-selection-label">
                        {i18n.t("campaigns.dialog.form.confirmation")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.confirmation")}
                        placeholder={i18n.t("campaigns.dialog.form.confirmation")}
                        labelId="confirmation-selection-label"
                        id="confirmation"
                        name="confirmation"
                        error={touched.confirmation && Boolean(errors.confirmation)}
                        disabled={!campaignEditable}
                      >
                        <MenuItem value={false}>Desabilitada</MenuItem>
                        <MenuItem value={true}>Habilitada</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="contactList-selection-label">
                        {i18n.t("campaigns.dialog.form.contactList")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.contactList")}
                        placeholder={i18n.t("campaigns.dialog.form.contactList")}
                        labelId="contactList-selection-label"
                        id="contactListId"
                        name="contactListId"
                        error={touched.contactListId && Boolean(errors.contactListId)}
                        disabled={!campaignEditable}
                      >
                        <MenuItem value="">Nenhuma</MenuItem>
                        {contactLists &&
                          contactLists.map((contactList) => (
                            <MenuItem key={contactList.id} value={contactList.id}>
                              {contactList.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="tagList-selection-label">
                        {i18n.t("campaigns.dialog.form.tagList")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.tagList")}
                        placeholder={i18n.t("campaigns.dialog.form.tagList")}
                        labelId="tagList-selection-label"
                        id="tagListId"
                        name="tagListId"
                        error={touched.tagListId && Boolean(errors.tagListId)}
                        disabled={!campaignEditable}
                      >
                        {Array.isArray(tagLists) &&
                          tagLists.map((tagList) => (
                            <MenuItem key={tagList.id} value={tagList.id}>
                              {tagList.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="whatsapp-selection-label" shrink={!!whatsappId}>
                        {i18n.t("campaigns.dialog.form.whatsapp")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.whatsapp")}
                        placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
                        labelId="whatsapp-selection-label"
                        id="whatsappIds"
                        name="whatsappIds"
                        required
                        error={touched.whatsappId && Boolean(errors.whatsappId)}
                        disabled={!campaignEditable}
                        value={whatsappId}
                        onChange={(event) => {
                          setWhatsappId(event.target.value)
                        }}
                      >
                        {whatsapps &&
                          whatsapps
                            .filter(w => campaignType === "template" ? w.channel === "whatsapp_oficial" : true)
                            .map((whatsapp) => (
                              <MenuItem key={whatsapp.id} value={whatsapp.id}>
                                {whatsapp.name}
                              </MenuItem>
                            ))}
                      </Field>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <Field
                      as={TextField}
                      label={i18n.t("campaigns.dialog.form.scheduledAt")}
                      name="scheduledAt"
                      error={touched.scheduledAt && Boolean(errors.scheduledAt)}
                      helperText={touched.scheduledAt && errors.scheduledAt}
                      variant="outlined"
                      margin="dense"
                      type="datetime-local"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        min: moment().format("YYYY-MM-DDTHH:mm"),
                      }}
                      fullWidth
                      className={classes.textField}
                      disabled={!campaignEditable}
                    />
                  </Grid>

                  {/* SEÇÃO DE RECORRÊNCIA */}
                  <Grid xs={12} item>
                    <Card className={classes.recurrenceCard}>
                      <CardContent>
                        <Box display="flex" alignItems="center" mb={2}>
                          <RepeatIcon className={classes.recurrenceIcon} />
                          <Typography variant="h6">
                            Configuração de Recorrência
                          </Typography>
                        </Box>
                        
                        <Grid spacing={2} container>
                          <Grid xs={12} item>
                            <FormControlLabel
                              control={
                                <Field
                                  as={Switch}
                                  name="isRecurring"
                                  checked={values.isRecurring}
                                  onChange={(e) => {
                                    setFieldValue('isRecurring', e.target.checked);
                                    if (!e.target.checked) {
                                      setPreviewExecutions([]);
                                      setShowPreview(false);
                                    }
                                  }}
                                  disabled={!campaignEditable}
                                />
                              }
                              label="Habilitar recorrência"
                            />
                          </Grid>

                          <Collapse in={values.isRecurring}>
                            <Grid spacing={2} container>
                              <Grid xs={12} md={3} item>
                                <FormControl
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  error={touched.recurrenceType && Boolean(errors.recurrenceType)}
                                >
                                  <InputLabel>Tipo de Recorrência</InputLabel>
                                  <Field
                                    as={Select}
                                    name="recurrenceType"
                                    label="Tipo de Recorrência"
                                    disabled={!campaignEditable}
                                    onChange={(e) => {
                                      setFieldValue('recurrenceType', e.target.value);
                                      // Reset outros campos quando mudar tipo
                                      setFieldValue('recurrenceDaysOfWeek', []);
                                      setFieldValue('recurrenceDayOfMonth', 1);
                                    }}
                                  >
                                    <MenuItem value="minutely">Por Minuto</MenuItem>
                                    <MenuItem value="hourly">Por Hora</MenuItem>
                                    <MenuItem value="daily">Diário</MenuItem>
                                    <MenuItem value="weekly">Semanal</MenuItem>
                                    <MenuItem value="biweekly">Quinzenal</MenuItem>
                                    <MenuItem value="monthly">Mensal</MenuItem>
                                    <MenuItem value="yearly">Anual</MenuItem>
                                  </Field>
                                  {touched.recurrenceType && errors.recurrenceType && (
                                    <FormHelperText error>{errors.recurrenceType}</FormHelperText>
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid xs={12} md={3} item>
                                <Field
                                  as={TextField}
                                  name="recurrenceInterval"
                                  label="Intervalo"
                                  type="number"
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  inputProps={{ min: 1 }}
                                  error={touched.recurrenceInterval && Boolean(errors.recurrenceInterval)}
                                  helperText={
                                    touched.recurrenceInterval && errors.recurrenceInterval ||
                                    `A cada ${values.recurrenceInterval || 1} ${
                                      values.recurrenceType === 'minutely' ? 'minuto(s)' :
                                      values.recurrenceType === 'hourly' ? 'hora(s)' :
                                      values.recurrenceType === 'daily' ? 'dia(s)' :
                                      values.recurrenceType === 'weekly' ? 'semana(s)' :
                                      values.recurrenceType === 'biweekly' ? 'quinzena(s)' :
                                      values.recurrenceType === 'monthly' ? 'mês(es)' :
                                      values.recurrenceType === 'yearly' ? 'ano(s)' : ''
                                    }`
                                  }
                                  disabled={!campaignEditable}
                                />
                              </Grid>

                              {/* Dias da semana para recorrência semanal */}
                              {values.recurrenceType === 'weekly' && (
                                <Grid xs={12} md={6} item>
                                  <Typography variant="subtitle2" gutterBottom>
                                    Dias da Semana
                                  </Typography>
                                  <FormGroup row>
                                    {daysOfWeekOptions.map((day) => (
                                      <FormControlLabel
                                        key={day.value}
                                        control={
                                          <Checkbox
                                            checked={values.recurrenceDaysOfWeek.includes(day.value)}
                                            onChange={(e) => {
                                              const currentDays = values.recurrenceDaysOfWeek || [];
                                              if (e.target.checked) {
                                                setFieldValue('recurrenceDaysOfWeek', [...currentDays, day.value]);
                                              } else {
                                                setFieldValue('recurrenceDaysOfWeek', 
                                                  currentDays.filter(d => d !== day.value)
                                                );
                                              }
                                            }}
                                            disabled={!campaignEditable}
                                          />
                                        }
                                        label={day.label.substring(0, 3)}
                                      />
                                    ))}
                                  </FormGroup>
                                  {touched.recurrenceDaysOfWeek && errors.recurrenceDaysOfWeek && (
                                    <FormHelperText error>{errors.recurrenceDaysOfWeek}</FormHelperText>
                                  )}
                                </Grid>
                              )}

                              {/* Dia do mês para recorrência mensal */}
                              {values.recurrenceType === 'monthly' && (
                                <Grid xs={12} md={3} item>
                                  <Field
                                    as={TextField}
                                    name="recurrenceDayOfMonth"
                                    label="Dia do Mês"
                                    type="number"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    inputProps={{ min: 1, max: 31 }}
                                    error={touched.recurrenceDayOfMonth && Boolean(errors.recurrenceDayOfMonth)}
                                    helperText={
                                      touched.recurrenceDayOfMonth && errors.recurrenceDayOfMonth ||
                                      "Dia específico do mês (1-31)"
                                    }
                                    disabled={!campaignEditable}
                                  />
                                </Grid>
                              )}

                              <Grid xs={12} md={4} item>
                                <Field
                                  as={TextField}
                                  name="recurrenceEndDate"
                                  label="Data Final (opcional)"
                                  type="date"
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  error={touched.recurrenceEndDate && Boolean(errors.recurrenceEndDate)}
                                  helperText={
                                    touched.recurrenceEndDate && errors.recurrenceEndDate ||
                                    "Deixe vazio para recorrência infinita"
                                  }
                                  disabled={!campaignEditable}
                                />
                              </Grid>

                              <Grid xs={12} md={4} item>
                                <Field
                                  as={TextField}
                                  name="maxExecutions"
                                  label="Máximo de Execuções (opcional)"
                                  type="number"
                                  variant="outlined"
                                  margin="dense"
                                  fullWidth
                                  inputProps={{ min: 1 }}
                                  error={touched.maxExecutions && Boolean(errors.maxExecutions)}
                                  helperText={
                                    touched.maxExecutions && errors.maxExecutions ||
                                    "Deixe vazio para recorrência infinita"
                                  }
                                  disabled={!campaignEditable}
                                />
                              </Grid>

                              <Grid xs={12} md={4} item>
                                <Button
                                  variant="outlined"
                                  startIcon={<VisibilityIcon />}
                                  onClick={() => {
                                    handlePreviewRecurrence(values);
                                    setShowPreview(!showPreview);
                                  }}
                                  disabled={!values.recurrenceType || !values.scheduledAt}
                                  fullWidth
                                  style={{ marginTop: 8 }}
                                >
                                  {showPreview ? 'Ocultar' : 'Visualizar'} Próximas Execuções
                                </Button>
                              </Grid>

                              {/* Preview das execuções */}
                              <Collapse in={showPreview && previewExecutions.length > 0}>
                                <Grid xs={12} item>
                                  <Card className={classes.previewCard}>
                                    <CardContent>
                                      <Typography variant="subtitle2" gutterBottom>
                                        Próximas 5 Execuções:
                                      </Typography>
                                      <List dense>
                                        {previewExecutions.slice(0, 5).map((execution, index) => (
                                          <ListItem key={index} divider>
                                            <ListItemText
                                              primary={`${index + 1}ª Execução`}
                                              secondary={typeof execution === 'string' ? execution : moment(execution).format('DD/MM/YYYY HH:mm')}
                                            />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              </Collapse>
                            </Grid>
                          </Collapse>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="openTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.openTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.openTicket")}
                        placeholder={i18n.t("campaigns.dialog.form.openTicket")}
                        labelId="openTicket-selection-label"
                        id="openTicket"
                        name="openTicket"
                        error={touched.openTicket && Boolean(errors.openTicket)}
                        disabled={!campaignEditable}
                      >
                        <MenuItem value={"enabled"}>{i18n.t("campaigns.dialog.form.enabledOpenTicket")}</MenuItem>
                        <MenuItem value={"disabled"}>{i18n.t("campaigns.dialog.form.disabledOpenTicket")}</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* SELECIONAR USUARIO */}
                  <Grid xs={12} md={4} item>
                    <Autocomplete
                      style={{ marginTop: '8px' }}
                      variant="outlined"
                      margin="dense"
                      className={classes.formControl}
                      getOptionLabel={(option) => `${option.name}`}
                      value={selectedUser}
                      size="small"
                      onChange={(e, newValue) => {
                        setSelectedUser(newValue);
                        if (newValue != null && Array.isArray(newValue.queues)) {
                          if (newValue.queues.length === 1) {
                            setSelectedQueue(newValue.queues[0].id);
                          }
                          setQueues(newValue.queues);
                        } else {
                          setQueues(allQueues);
                          setSelectedQueue("");
                        }
                      }}
                      options={options}
                      filterOptions={filterOptions}
                      freeSolo
                      fullWidth
                      autoHighlight
                      disabled={!campaignEditable || values.openTicket === 'disabled'}
                      noOptionsText={i18n.t("transferTicketModal.noOptions")}
                      loading={loading}
                      renderOption={option => (<span> <UserStatusIcon user={option} /> {option.name}</span>)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={i18n.t("transferTicketModal.fieldLabel")}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel>
                        {i18n.t("transferTicketModal.fieldQueueLabel")}
                      </InputLabel>
                      <Select
                        value={selectedQueue}
                        onChange={(e) => setSelectedQueue(e.target.value)}
                        label={i18n.t("transferTicketModal.fieldQueuePlaceholder")}
                        required={!isNil(selectedUser)}
                        disabled={!campaignEditable || values.openTicket === 'disabled'}
                      >
                        {queues.map((queue) => (
                          <MenuItem key={queue.id} value={queue.id}>
                            {queue.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="statusTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.statusTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.statusTicket")}
                        placeholder={i18n.t("campaigns.dialog.form.statusTicket")}
                        labelId="statusTicket-selection-label"
                        id="statusTicket"
                        name="statusTicket"
                        error={touched.statusTicket && Boolean(errors.statusTicket)}
                        disabled={!campaignEditable || values.openTicket === 'disabled'}
                      >
                        <MenuItem value={"closed"}>{i18n.t("campaigns.dialog.form.closedTicketStatus")}</MenuItem>
                        <MenuItem value={"pending"}>{i18n.t("campaigns.dialog.form.pendingTicketStatus")}</MenuItem>
                        <MenuItem value={"open"}>{i18n.t("campaigns.dialog.form.openTicketStatus")}</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* SEÇÃO DE MENSAGENS (apenas para campanha normal) */}
                  {campaignType === "normal" && <Grid xs={12} item>
                    <Tabs
                      value={messageTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={(e, v) => setMessageTab(v)}
                      variant="fullWidth"
                      centered
                      style={{
                        background: theme.palette.tabHeaderBackground,
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 2,
                      }}
                    >
                      <Tab label="Msg. 1" index={0} />
                      <Tab label="Msg. 2" index={1} />
                      <Tab label="Msg. 3" index={2} />
                      <Tab label="Msg. 4" index={3} />
                      <Tab label="Msg. 5" index={4} />
                    </Tabs>
                    <Box style={{ paddingTop: 20, border: "none" }}>
                      {messageTab === 0 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                <>{renderMessageField("message1")}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>{renderConfirmationMessageField("confirmationMessage1")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message1")}</>
                          )}
                        </>
                      )}
                      {messageTab === 1 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                <>{renderMessageField("message2")}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>{renderConfirmationMessageField("confirmationMessage2")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message2")}</>
                          )}
                        </>
                      )}
                      {messageTab === 2 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                <>{renderMessageField("message3")}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>{renderConfirmationMessageField("confirmationMessage3")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message3")}</>
                          )}
                        </>
                      )}
                      {messageTab === 3 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                <>{renderMessageField("message4")}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>{renderConfirmationMessageField("confirmationMessage4")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message4")}</>
                          )}
                        </>
                      )}
                      {messageTab === 4 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={8} item>
                                <>{renderMessageField("message5")}</>
                              </Grid>
                              <Grid xs={12} md={4} item>
                                <>{renderConfirmationMessageField("confirmationMessage5")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message5")}</>
                          )}
                        </>
                      )}
                    </Box>
                  </Grid>}

                  {/* EDITOR TEMPLATE META (apenas para template) */}
                  {campaignType === "template" && (
                    <Grid xs={12} item>
                      <Box style={{ border: `1px solid ${theme.palette.divider}`, borderRadius: 12, padding: "20px", background: theme.palette.background.paper }}>

                        {/* Nome do template Meta (nome do template aprovado na Meta) */}
                        <TextField
                          label="Nome do template Meta"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={templateName}
                          onChange={(e) => setTemplateName(e.target.value)}
                          placeholder="Ex: meu_template_aprovado"
                          style={{ marginBottom: 16, background: theme.palette.background.paper, borderRadius: 8 }}
                        />

                        {/* Mensagem do template Meta */}
                        <TextField
                          label="Mensagem do template Meta"
                          variant="outlined"
                          size="small"
                          fullWidth
                          multiline
                          minRows={4}
                          value={templateBody}
                          onChange={(e) => setTemplateBody(e.target.value)}
                          placeholder={"Olá, {{nome}}. Temos uma atualização sobre seu pedido: {{mensagem_atualizacao}}."}
                          style={{ marginBottom: 4, background: theme.palette.background.paper, borderRadius: 8 }}
                        />
                        <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 24 }}>
                          Exemplo: Olá, {"{{nome}}"}. Temos uma atualização sobre seu pedido: {"{{mensagem_atualizacao}}"}.<br />
                          Se precisar de ajuda, contate nosso suporte.
                        </Typography>

                        {/* Download dos itens já cadastrados (apenas na edição) */}
                        {campaignId && existingItemsCount > 0 && (
                          <Box
                            style={{
                              display: "flex", flexDirection: "column", alignItems: "center",
                              gap: 8, marginBottom: 16, padding: "16px",
                              border: "2px solid #4caf50", borderRadius: 12, background: "rgba(76,175,80,0.04)",
                              cursor: "pointer", transition: "all 0.2s",
                            }}
                            onClick={handleDownloadExistingItems}
                          >
                            <CloudDownloadIcon style={{ fontSize: 36, color: "#4caf50" }} />
                            <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#4caf50" }}>
                              Baixar template atual ({existingItemsCount} contatos)
                            </Typography>
                            <Typography variant="caption" style={{ color: "#888", textAlign: "center" }}>
                              Exporta os dados já cadastrados para editar e reimportar
                            </Typography>
                          </Box>
                        )}

                        {/* Validar contatos no WhatsApp — travado até escolher a lista */}
                        <Box
                          style={{
                            display: "flex", flexDirection: "column", alignItems: "center",
                            gap: 8, marginBottom: 16, padding: "16px",
                            border: `2px dashed ${values.contactListId ? "#ff9800" : "#ccc"}`,
                            borderRadius: 12,
                            background: values.contactListId ? theme.palette.background.paper : "transparent",
                            cursor: values.contactListId ? "pointer" : "not-allowed",
                            opacity: values.contactListId ? 1 : 0.5,
                            transition: "all 0.2s",
                          }}
                          onClick={() => {
                            if (!values.contactListId) {
                              toast.warning("Selecione uma Lista de Contato primeiro.");
                              return;
                            }
                            setValidateModalOpen(true);
                          }}
                        >
                          <VerifiedUserIcon style={{ fontSize: 36, color: values.contactListId ? "#ff9800" : "#aaa" }} />
                          <Typography variant="subtitle2" style={{ fontWeight: 600, color: values.contactListId ? "#ff9800" : "#aaa" }}>
                            Validar contatos no WhatsApp
                          </Typography>
                          <Typography variant="caption" style={{ color: "#888", textAlign: "center" }}>
                            Checa, usando uma conexão normal, quais contatos da lista têm WhatsApp de verdade — remove os inválidos do template abaixo.
                          </Typography>
                        </Box>

                        <ValidateContactListModal
                          open={validateModalOpen}
                          onClose={() => setValidateModalOpen(false)}
                          contactListId={values.contactListId}
                          whatsapps={whatsapps}
                          onValidated={() => setValidatedContactListId(values.contactListId)}
                        />

                        {/* Baixar template */}
                        <Box
                          style={{
                            display: "flex", flexDirection: "column", alignItems: "center",
                            gap: 8, marginBottom: 16, padding: "20px",
                            border: "2px dashed #90caf9", borderRadius: 12, background: theme.palette.background.paper,
                            cursor: "pointer", transition: "all 0.2s",
                          }}
                          onClick={() => handleDownloadTemplate(values.contactListId)}
                        >
                          <CloudDownloadIcon style={{ fontSize: 48, color: "#1976d2" }} />
                          <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#1976d2" }}>
                            Baixar template da campanha
                          </Typography>
                          <Typography variant="caption" style={{ color: "#888", textAlign: "center" }}>
                            Gera um Excel com os contatos da lista selecionada.<br />
                            Para parâmetros do corpo: <b>Parâmetro N / Valor N</b> (ex: <b>1</b> ou <b>nome</b>).<br />
                            Para botões com URL dinâmica: use <b>button_0</b>, <b>button_1</b>... como valor do parâmetro.
                            {validatedContactListId === values.contactListId && (
                              <><br /><b style={{ color: "#4caf50" }}>✓ Contatos validados — números sem WhatsApp serão excluídos.</b></>
                            )}
                          </Typography>
                        </Box>

                        {/* Importar template */}
                        <input
                          type="file"
                          accept=".xlsx,.xls"
                          ref={templateFileRef}
                          style={{ display: "none" }}
                          onChange={handleImportTemplate}
                        />
                        <Box
                          style={{
                            display: "flex", flexDirection: "column", alignItems: "center",
                            gap: 8, padding: "20px",
                            border: templateFile ? "2px solid #4caf50" : "2px dashed #bdbdbd",
                            borderRadius: 12, background: theme.palette.background.paper,
                            cursor: "pointer", transition: "all 0.2s",
                          }}
                          onClick={() => templateFileRef.current.click()}
                        >
                          {templateFile ? (
                            <>
                              <CheckCircleIcon style={{ fontSize: 48, color: "#4caf50" }} />
                              <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#4caf50" }}>
                                {parsedItems.length} contatos carregados
                              </Typography>
                              <Typography variant="caption" style={{ color: "#888" }}>
                                {templateFile.name} · Clique para substituir
                              </Typography>
                            </>
                          ) : (
                            <>
                              <CloudUploadIcon style={{ fontSize: 48, color: "#9e9e9e" }} />
                              <Typography variant="subtitle1" style={{ fontWeight: 600, color: "#555" }}>
                                Importar template preenchido
                              </Typography>
                              <Typography variant="caption" style={{ color: "#888", textAlign: "center" }}>
                                Clique para selecionar o arquivo .xlsx
                              </Typography>
                            </>
                          )}
                        </Box>

                      </Box>
                    </Grid>
                  )}

                  {(campaign.mediaPath || attachment) && (
                    <Grid xs={12} item>
                      <Button startIcon={<AttachFileIcon />}>
                        {attachment != null ? attachment.name : campaign.mediaName}
                      </Button>
                      {campaignEditable && (
                        <IconButton
                          onClick={() => setConfirmationOpen(true)}
                          color="primary"
                        >
                          <DeleteOutlineIcon color="secondary" />
                        </IconButton>
                      )}
                    </Grid>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions>
                {campaign.status === "CANCELADA" && (
                  <Button
                    color="primary"
                    onClick={() => restartCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.restart")}
                  </Button>
                )}
                {campaign.status === "EM_ANDAMENTO" && (
                  <Button
                    color="primary"
                    onClick={() => cancelCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.cancel")}
                  </Button>
                )}
                {!attachment && !campaign.mediaPath && campaignEditable && campaignType === "normal" && (
                  <Button
                    color="primary"
                    onClick={() => attachmentFile.current.click()}
                    disabled={isSubmitting}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.attach")}
                  </Button>
                )}
                <Typography
                  variant="caption"
                  className={classes.warningText}
                >
                  ⚠️ A GoLiveZap não se responsabiliza pela utilização de automação sem uso da API Não Oficial da Meta para envio de mensagens, o que pode gerar banimentos e restrições ao número.
                </Typography>
                <Button
                  onClick={handleClose}
                  color="primary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("campaigns.dialog.buttons.close")}
                </Button>
                {(campaignEditable || campaign.status === "CANCELADA") && (
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {campaignId
                      ? `${i18n.t("campaigns.dialog.buttons.edit")}`
                      : `${i18n.t("campaigns.dialog.buttons.add")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default CampaignModal;